// @flow
import React from 'react';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { ArticleDetail, ArticleSide, Video } from '../../../components';

type Props = {
  location: Object,
  history: Object,
  toggleModal: Function
};

export const Impuestos = ({ location, history, toggleModal }: Props) => {
  const redirectTo = (url: string) => {
    history.push(url);
  };

  return (
    <ArticleDetail
      location={location}
      title="Un asesor financiero te ayudará a pagar sólo lo justo a Hacienda."
      redirectTo={redirectTo}
      toggleModal={toggleModal}
    >
      <Paragraph>
        Con las inversiones puede pasar lo mismo que con el fútbol o la política, cualquiera puede tener una opinión de
        si la bolsa subirá o bajará. Otra cosa es que se equivoque. Pero con los impuestos es muy distinto: como no
        tengamos un experto fiscal cerca puede que acabemos pagando mucho más de lo que deberíamos.
      </Paragraph>
      <ArticleSide full position="right">
        <Video
          id="MIcXDEc7E1U"
          src="https://www.youtube.com/embed/MIcXDEc7E1U?hd=1&showinfo=0&controls=0&rel=0&enablejsapi=1"
          caption="María Muñoz, Andbak."
        />
      </ArticleSide>
      <Paragraph>
        El lado ‘fiscal’ de nuestras finanzas puede acabar marcando la diferencia entre alcanzar nuestros objetivos o
        quedarnos a medio camino. Y no sólo a la hora de rendir cuentas a Hacienda con la declaración de cada año,
        evitando errores o perdiéndonos desgravaciones que deberíamos aprovechar.
      </Paragraph>
      <Paragraph>
        También a la hora de configurar nuestra cartera e incluso elegir nuestras inversiones. ¿Mejor un plan de
        pensiones para desgravar o un fondo de inversión para tener liquidez? ¿Cómo debemos alquilar nuestra vivienda
        para que la rentabilidad por alquiler sea mayor después de impuestos?
      </Paragraph>
      <Paragraph>
        ¿Cómo rescatar nuestro ahorro para la jubilación sin pagar una fortuna al fisco? ¿Cuál es la mejor forma de
        cobrar la herencia? ¿O cómo dejar la herencia a nuestros hijos para que después no tengan que pagar una fortuna
        en impuestos?
      </Paragraph>
      <Paragraph>
        Todo este mar de dudas lo resolverás sentándote con un buen asesor financiero y planificando bien toda tu
        situación familiar y financiera. No sólo mejorará la rentabilidad financiero fiscal del dinero que tanto te
        cuesta ahorrar, sino que te quitará el dolor de cabeza de cómo organizar tu ‘relación’ con Hacienda.
      </Paragraph>
    </ArticleDetail>
  );
};
